import { render } from "./SchaltflaecheEditChildren.pug?vue&type=template&id=f3ba5f1c&lang=pug"
import script from "./SchaltflaecheEditChildren.js?vue&type=script&lang=js"
export * from "./SchaltflaecheEditChildren.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__